import styled from 'styled-components';
import { OrderPanelStyledAC as OrderPanelStyled } from '../OrderPanelStyled.AC';

export const OrderPanelStyledAC = styled(OrderPanelStyled)``;
